import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = { class: "lg:text-lg text-lg text-center lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_6 = { class: "bg-white shadow overflow-hidden sm:rounded-lg mt-4" }
const _hoisted_7 = { class: "border-t border-gray-200 px-4 py-5 sm:px-6" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2" }
const _hoisted_9 = { class: "sm:col-span-1" }
const _hoisted_10 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_11 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_12 = { class: "sm:col-span-1" }
const _hoisted_13 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_14 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_15 = { class: "sm:col-span-1" }
const _hoisted_16 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dd", { class: "mt-1 text-sm text-gray-900" }, "info@curaduria2monteria.com", -1)
const _hoisted_18 = { class: "sm:col-span-1" }
const _hoisted_19 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dd", { class: "mt-1 text-sm text-gray-900" }, "info@curaduria2monteria.com", -1)
const _hoisted_21 = { class: "sm:col-span-1" }
const _hoisted_22 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_23 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_24 = { class: "sm:col-span-1" }
const _hoisted_25 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_26 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_27 = { class: "sm:col-span-1" }
const _hoisted_28 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_29 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_30 = { class: "sm:col-span-1" }
const _hoisted_31 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_32 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_33 = { class: "sm:col-span-1" }
const _hoisted_34 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("dd", { class: "mt-1 text-sm text-gray-900" }, "info@curaduria2monteria.com", -1)
const _hoisted_36 = { class: "sm:col-span-1" }
const _hoisted_37 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_38 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_39 = {
  id: "policy",
  class: "relative bg-gray-300 rounded-lg shadow mt-2"
}
const _hoisted_40 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_41 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_42 = { class: "font-medium text-curaduriaDark" }
const _hoisted_43 = { class: "md:hidden" }
const _hoisted_44 = { class: "hidden md:inline" }
const _hoisted_45 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_46 = {
  href: "https://drive.google.com/file/d/1-cT4Zv9jXY5P5zLqFiz8GB-dZJcVGWU_/view?usp=sharing",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_48 = {
  id: "flowchart",
  class: "relative bg-gray-300 rounded-lg shadow mt-2"
}
const _hoisted_49 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_50 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_51 = { class: "font-medium text-curaduriaDark" }
const _hoisted_52 = { class: "md:hidden" }
const _hoisted_53 = { class: "hidden md:inline" }
const _hoisted_54 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_55 = {
  href: "https://drive.google.com/file/d/12jtsiru9zQPAV8fFLxJSoP4NG7Cathd2/view?usp=sharing",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_57 = { class: "relative bg-gray-300 rounded-lg shadow mt-2 flex justify-center" }
const _hoisted_58 = { class: "py-3 px-3 w-full max-w-xl flex items-center justify-center gap-2" }
const _hoisted_59 = { class: "text-curaduriaDark font-bold" }
const _hoisted_60 = ["href"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_62 = { class: "relative bg-gray-300 rounded-lg shadow mt-2 flex justify-center" }
const _hoisted_63 = { class: "py-3 px-3 w-full max-w-xl flex items-center justify-center gap-2" }
const _hoisted_64 = { class: "text-curaduriaDark font-bold" }
const _hoisted_65 = ["href"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_67 = { class: "relative bg-gray-300 rounded-lg shadow mt-2 flex justify-center" }
const _hoisted_68 = { class: "py-3 px-3 w-full max-w-xl flex items-center justify-center gap-2" }
const _hoisted_69 = { class: "text-curaduriaDark font-bold" }
const _hoisted_70 = ["href"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_72 = { class: "relative bg-gray-300 rounded-lg shadow mt-2 flex justify-center" }
const _hoisted_73 = { class: "py-3 px-3 w-full max-w-xl flex items-center justify-center gap-2" }
const _hoisted_74 = { class: "text-curaduriaDark font-bold" }
const _hoisted_75 = ["href"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("transparency.title")), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("transparency.des")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("dl", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("dt", _hoisted_10, _toDisplayString(_ctx.$t("transparency.locationTitle")), 1),
                _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.$t("transparency.locationDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("dt", _hoisted_13, _toDisplayString(_ctx.$t("transparency.scheduleTitle")), 1),
                _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.$t("transparency.scheduleDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("dt", _hoisted_16, _toDisplayString(_ctx.$t("transparency.emailTitle")), 1),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("dt", _hoisted_19, _toDisplayString(_ctx.$t("transparency.emailNotTitle")), 1),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("dt", _hoisted_22, _toDisplayString(_ctx.$t("transparency.addressTitle")), 1),
                _createElementVNode("dd", _hoisted_23, _toDisplayString(_ctx.$t("transparency.addressDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("dt", _hoisted_25, _toDisplayString(_ctx.$t("transparency.telTitle")), 1),
                _createElementVNode("dd", _hoisted_26, _toDisplayString(_ctx.$t("transparency.telDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("dt", _hoisted_28, _toDisplayString(_ctx.$t("transparency.celTitle")), 1),
                _createElementVNode("dd", _hoisted_29, _toDisplayString(_ctx.$t("transparency.celDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("dt", _hoisted_31, _toDisplayString(_ctx.$t("transparency.faxTitle")), 1),
                _createElementVNode("dd", _hoisted_32, _toDisplayString(_ctx.$t("transparency.faxDes")), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("dt", _hoisted_34, _toDisplayString(_ctx.$t("transparency.emailInstTitle")), 1),
                _hoisted_35
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("dt", _hoisted_37, _toDisplayString(_ctx.$t("transparency.emailPhisTitle")), 1),
                _createElementVNode("dd", _hoisted_38, _toDisplayString(_ctx.$t("transparency.emailPhisDes")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("p", _hoisted_42, [
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("transparency.termsPolicy")), 1),
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("transparency.termsPolicy")), 1),
                _createElementVNode("span", _hoisted_45, [
                  _createElementVNode("a", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.$t("transparency.navLink")) + " ", 1),
                    _hoisted_47
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", _hoisted_51, [
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("transparency.transactionalFlow")), 1),
                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("transparency.transactionalFlow")), 1),
                _createElementVNode("span", _hoisted_54, [
                  _createElementVNode("a", _hoisted_55, [
                    _createTextVNode(_toDisplayString(_ctx.$t("transparency.navLink")) + " ", 1),
                    _hoisted_56
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('transparency.rates.years.2023.label')), 1),
            _createElementVNode("a", {
              href: _ctx.$t('transparency.rates.years.2023.link'),
              target: "_blank",
              class: "text-curaduriaDark underline font-semibold"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('transparency.rates.navLink')) + " ", 1),
              _hoisted_61
            ], 8, _hoisted_60)
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('transparency.rates.years.2024.label')), 1),
            _createElementVNode("a", {
              href: _ctx.$t('transparency.rates.years.2024.link'),
              target: "_blank",
              class: "text-curaduriaDark underline font-semibold"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('transparency.rates.navLink')) + " ", 1),
              _hoisted_66
            ], 8, _hoisted_65)
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('transparency.rates.years.2025.label')), 1),
            _createElementVNode("a", {
              href: _ctx.$t('transparency.rates.years.2025.link'),
              target: "_blank",
              class: "text-curaduriaDark underline font-semibold"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('transparency.rates.navLink')) + " ", 1),
              _hoisted_71
            ], 8, _hoisted_70)
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('transparency.rates.years.2026.label')), 1),
            _createElementVNode("a", {
              href: _ctx.$t('transparency.rates.years.2026.link'),
              target: "_blank",
              class: "text-curaduriaDark underline font-semibold"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('transparency.rates.navLink')) + " ", 1),
              _hoisted_76
            ], 8, _hoisted_75)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}